const shiftPatternDropdown = [
    { id: 'F', label: 'Full Time' },
    { id: 'P', label: 'Part Time' }
];

export default shiftPatternDropdown;